// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3YEMs","head":"Table_head__2ySb7","col":"Table_col__3B2X8"};